import { NgModule } from '@angular/core';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { RRSharedModule } from '../shared-module/shared.module';
import { NgxUploaderModule } from 'ngx-uploader';
import { RRBootstrapModule } from '../bootstrap/bootstrap.module';

@NgModule({
  declarations: [FileUploadComponent],
  imports: [RRSharedModule, NgxUploaderModule, RRBootstrapModule],
  exports: [FileUploadComponent],
})
export class RRFileUploadModule {}
